// extracted by mini-css-extract-plugin
module.exports = {"tagBox":"style-module--tagBox--xSq3A","tagLink":"style-module--tagLink--33ljf","tagLinkLarge":"style-module--tagLinkLarge--3JkBZ"};